import React from 'react';

export const WhatsAppIcon = ({ className }: { className?: string }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    className={className}
  >
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.536 0 1.52 1.115 2.988 1.264 3.186.149.198 2.19 3.325 5.296 4.663 3.106 1.338 3.106 1.338 3.106 1.338 1.419.037 2.152-.597 2.152-.597.693-.693.891-1.683.891-1.683.198-.842.149-1.585.149-1.585-.05-.297-.247-.446-.544-.594zM12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm.062 19.985h-.006c-2.302 0-4.47-.735-6.284-2.003l-.45-.316-3.722 1.196 1.21-3.57-.33-.526c-1.41-2.257-1.846-4.966-.997-7.627 1.137-3.531 4.476-5.932 8.185-5.932 4.757 0 8.629 3.872 8.629 8.629s-3.872 8.629-8.629 8.629z" />
  </svg>
);
